import t from '../actions/actionTypes'

const defaultState = {
	authenticationFailed: false,
	recoveryKey: {
		isValid: null,
		value: null,
		mustAcceptTerms: '0',
	},
	email: '',
}

function saveRecoveryKey(state, action) {
	const newState = {...state}
	const newRecoveryKey = {...state.recoveryKey}
	newRecoveryKey.isValid = true
	newRecoveryKey.value = action.data.recoveryKey
	newRecoveryKey.mustAcceptTerms = action.data.mustAcceptTerms
	//newData.redirectUrl = action.data.redirectUrl
	newState.recoveryKey = newRecoveryKey
	return newState
}

function setTeacherEmail(state, action) {
	return {
		...state,
		email: action.email,
	}
}

function resetTeacherEmail(state) {
	return {
		...state,
		email: '',
	}
}

const shareReducer = (state = defaultState, action) => {
	switch (action.type) {
		case t.LOGIN_AUTHENTICATION_FAILED: {
			const newState = {...state}
			newState.authenticationFailed = true
			return newState
		}
		case t.LOGIN_RESET_AUTHENTICATION: {
			const newState = {...state}
			newState.authenticationFailed = false
			return newState
		}
		case t.LOGIN_SAVE_RECOVERY_KEY: {
			return saveRecoveryKey(state, action)
		}
		case t.LOGIN_VALID_RECOVERY_KEY: {
			const newState = {...state}
			newState.recoveryKey = Object.assign({}, state.recoveryKey, {
				isValid: true,
				value: action.key,
				mustAcceptTerms: action.mustAcceptTerms,
			})
			return newState
		}
		case t.SIGNUP_TEACHER_EMAIL_ALREADY_REGISTERED:
			return setTeacherEmail(state, action)
		case t.LOGIN_FINALIZE:
			return resetTeacherEmail(state)

		default:
			return state
	}
}

export default shareReducer
